import {Component, Input, OnInit, Optional} from '@angular/core';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {TRANSLATION_EDITOR_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';

// hack to inject decorator declarations. must occur before class declaration!
export interface QuestionTypeEmailComponent extends Translatable {}

@Component({
  selector: 'app-qa-question-email',
  templateUrl: './question-type-email.component.html',
  styleUrls: ['./question-type-email.component.css', '../../../shared/reusable.css']
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class QuestionTypeEmailComponent implements OnInit {
  @Input() question: Questionnaire.Container;

  public locale = 'de_DE';
  public recipientsFixedStr = '';
  public recipientsInvalid = false;
  public validMailRegex = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

  public constructor(
    @Optional() private translationService: TranslationService,
  ) {}

  public ngOnInit() {
    !this.question.options && (this.question.options = {});
    !this.question.options['email'] && (this.question.options['email'] = {
      recipientsFixed: [],
      sendToAssigner: false,
      sendToFiller: false,
      attachFilledPdf: false,
      attachReportPdf: false,
      includeAssetLinks: false
    });

    const recipients = this.question.options['email'].recipientsFixed || [];
    this.recipientsFixedStr = Array.isArray(recipients) ? recipients.join(', ') : '';
    this.validateRecipients();
  }

  public onRecipientsChanged() {
    const parts = (this.recipientsFixedStr || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => !!s);

    this.question.options['email'].recipientsFixed = parts;
    this.validateRecipients();
  }

  private validateRecipients() {
    const list = (this.recipientsFixedStr || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s.length > 0);

    // empty list is valid in editor context (other recipient options may be used)
    for (const recipient of list) {
      if (!this.validMailRegex.test(recipient) || recipient.length >= 300) {
        this.recipientsInvalid = true;
        return;
      }
    }
    this.recipientsInvalid = false;
  }
}


